import { render, staticRenderFns } from "./TrPaint.vue?vue&type=template&id=cf6c8ba8&scoped=true&"
import script from "./TrPaint.vue?vue&type=script&lang=js&"
export * from "./TrPaint.vue?vue&type=script&lang=js&"
import style0 from "./TrPaint.vue?vue&type=style&index=0&id=cf6c8ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6c8ba8",
  null
  
)

export default component.exports